var ConfirmationDialog = {
  extend: () => {
  }
};
export { ConfirmationDialog as default };
